// extracted by mini-css-extract-plugin
export default {"TabContext":"TabContext_TabContext__vBzVS"};